import React, { useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonHeader, IonContent } from '@ionic/react'
import { Input } from '@cps'
import { menuMobx, cartMobx } from 'restaurant'
import hotProductMobx from 'mobx/menu/hotProduct.mobx'
import { voiceServiceMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import { useDebounce } from '@dt/fe-utils'
import { mpc } from '@dt/mmg-sdk'
import { WaterfallProductItem, WaterfallActivityItem, WaterfallItem } from './components'
import NoSearchImg from '@img/no_search.png'
import { RouteComponentProps } from 'react-router-dom'
import { MallController, MallStyleController } from '@ctrls/mallController'

import './index.scss'
interface IProps extends RouteComponentProps {

}

// 存储计算结果
const lineToResult = {}
const Search: React.FC<IProps> = () => {
  const history = useHistoryNew()
  const { productNoToCntMap } = cartMobx.cartResult
  const { searchList: resultList, isOpenSearchActivity } = voiceServiceMobx

  const isProduct = useMemo(() => {
    const res = !resultList.length || resultList.length && ['mallProduct'].includes(resultList[0].type ? resultList[0].type : resultList[0].content_type)
    return res
  }, [resultList])

  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })

  useEffect(() => {
    hotProductMobx.initMall()

    return () => {
      menuMobx.setSearchKey('')
      voiceServiceMobx.setSearchList([])
    }
  }, [])

  const hashProduct = useMemo(() => {
    return resultList.map(p => p.no || p.contextId).join('')
  }, [resultList])
  const calcWaterfall = () => {
    const payload = MallStyleController.waterfall(resultList, false, isProduct ? 'no' : 'contextId', 'search')
    if (payload) {
      const { styleMap } = payload
      lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      // setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    if (resultList.length && hashProduct) {
      if (lineToResult[hashProduct]) {
        setProductStyleMap(lineToResult[hashProduct].styleMap)
        // setHeight(lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [hashProduct])

  const handleSelectProduct = (result) => {
    MallController.goToProduct(result)
  }

  const handleCancelSearch = () => {
    history.goBack()
  }

  const handleSearch = useDebounce(async (e) => {
    const res = await voiceServiceMobx.contentMatch(e.target.value)
    const { content: list, info } = res
    if (list.filter(item => item.content_type === 'call_activity').length) {
      if (isOpenSearchActivity) {
        const act = await mpc.refreshActivity()
        const availableActsMap = await voiceServiceMobx.getActsList(act)
        voiceServiceMobx.setSearchList(availableActsMap)
        return
      }
      voiceServiceMobx.setSearchList([])
    } else {
      const searchedProducts = voiceServiceMobx.getSearchedMallProducts(list)
      voiceServiceMobx.setSearchList(searchedProducts)
    }
  }, 500)

  return (
    <IonPage className='search-page'>
      <IonHeader>
        <div className='search-input-wrapper'>
          <span onClick={handleCancelSearch} className='btn-back'>
            <i className='iconfont icon-BACK-12x'></i>
          </span>
          <Input
            icon='iconfont icon-search'
            placeholder={i18n.t('mall.searchProduct')}
            value={menuMobx.searchKey || ''}
            onChange={(e) => {
              menuMobx.setSearchKey(e.target.value)
              if (![undefined, null, ''].includes(String(e.target.value).trim())) {
                handleSearch(e)
              } else {
                // setResultList([])
                voiceServiceMobx.setSearchList([])
              }
            }}
            autoFocus
          />
        </div>
      </IonHeader>
      <IonContent className='search-content'>
        {!!(!menuMobx.searchKey && hotProductMobx.HotMallViewProduct.length) && (
          <div className='hot-product-wrapper'>
            <h5>{i18n.t('mall.hotProduct')}</h5>
            {hotProductMobx.HotMallViewProduct.map((product) => {
              return (
                <div
                  className='simple-product'
                  onClick={() => handleSelectProduct(product)}
                  key={product.no}
                >
                  {product.name}
                </div>
              )
            })}
          </div>
        )}
        <div className='search-product-split'></div>
        {menuMobx.searchKey && (
          <div className='search-product-list waterfall-template search-mall-waterfall-template'>
            {
              resultList.length ? (
                resultList.map((result) => {
                  const id = isProduct ? result.no : result.contextId
                  return (
                    <WaterfallItem
                      key={id}
                      className='mall'
                      lazy={false}
                      style={productStyleMap[id]}
                      id={'waterfallsearch' + id}
                      onClick={() => handleSelectProduct(result)}
                    >
                      {
                        isProduct ? (
                          <WaterfallProductItem
                            product={result}
                            count={productNoToCntMap?.[id] || 0}
                          />
                        ) : (
                          <WaterfallActivityItem
                            data={result}
                          />
                        )
                      }
                    </WaterfallItem>
                  )
                })
              ) : (
                <div className='empty-info'>
                  <img src={NoSearchImg} alt='' className='empty-info-pic' />
                  <p>{i18n.t('mall.noSearchProduct')}</p>
                </div>
              )
            }
          </div>
        )}
      </IonContent>
    </IonPage>
  )
}

export default observer(Search)
